export default "__VITE_ASSET__CgO6EUS$__"